import { createElement } from "@wordpress/element";
/**
 * WordPress dependencies
 */

import { AsyncModeProvider, useSelect } from '@wordpress/data';

var BlockAsyncModeProvider = function BlockAsyncModeProvider(_ref) {
  var children = _ref.children,
      clientId = _ref.clientId,
      isBlockInSelection = _ref.isBlockInSelection;
  var isParentOfSelectedBlock = useSelect(function (select) {
    return select('core/block-editor').hasSelectedInnerBlock(clientId, true);
  });
  var isSyncModeForced = isBlockInSelection || isParentOfSelectedBlock;
  return createElement(AsyncModeProvider, {
    value: !isSyncModeForced
  }, children);
};

export default BlockAsyncModeProvider;